import React from 'react';
import { useSelector } from 'react-redux';
import { notificationsFeatureFlagSelector, unreadNotificationsCountSelector } from '@/store/store';
import { BellIcon } from '@/assets/Icons';
import { Icon } from '@/components/shared/display/Icon';

interface NotificationsBadgeProps {
  label: string;
}

const NotificationsBadge = ({ label }: NotificationsBadgeProps) => {
  return (
    <div className="rounded-full bg-[#FF0000] text-white w-5 h-5 absolute left-2 top-[-3px] border-2 border-[#2f2f66] flex justify-center items-center font-bold">
      {label}
    </div>
  );
};

export const NotificationsIconElement = () => {
  const notificationsFeatureFlag = useSelector(notificationsFeatureFlagSelector);
  const unreadNotificationsCount = useSelector(unreadNotificationsCountSelector);

  return (
    <div className="relative">
      <Icon icon={BellIcon} className="mb-[4.5px] w-7 h-7" />
      {!!unreadNotificationsCount && !!notificationsFeatureFlag && (
        <NotificationsBadge label={unreadNotificationsCount.toString()} />
      )}
    </div>
  );
};
